import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Icon,
  IconButton,
  Radio,
  RadioGroup,
  Slide,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import {
  StandardButton,
  StandardText,
} from "../../../../../../globalComponents/standard";

import Transaction from "../../../../../../classes/transaction";
import { TransitionSlideUp } from "../../../../../../components/misc/common";
import { GlobalContext } from "../../../../../../globalComponents/context";
import {
  FieldSelector,
  FieldText,
} from "../../../../../../globalComponents/forms";
import CustomerDetailsContext from "../../context";
import TransactionsContext from "../context";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function RegisterComponent({ children }) {
  const [open, setOpen] = React.useState(false);
  const { showAlert, showLoading } = useContext(GlobalContext);
  const { balances, updateBalances } = useContext(CustomerDetailsContext);

  const {
    create,
    transactionTypes,
    transactionSources,
    generateNewTransaction,
  } = useContext(TransactionsContext);
  const [transaction, setTransaction] = React.useState({
    ...generateNewTransaction(),
  });

  const refs = {};

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      // Prevent closing on backdrop click
      return;
    }
    setOpen(false);
  };

  const handleSave = () => {
    create(transaction, () => {
      handleClose();
      updateBalances();
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTransaction((p) => ({ ...p, [name]: value }));
  };

  const isValid = React.useMemo(
    () => Transaction.validate(transaction, balances.balance),
    [transaction, balances.balance],
  );

  useEffect(() => {
    //reset form
    if (!open) setTransaction({ ...generateNewTransaction() });
  }, [open]);

  return (
    <div>
      {children({ handleClickOpen })}
      <Dialog
        open={open}
        disableEnforceFocus
        disableEscapeKeyDown
        keepMounted={false}
        closeAfterTransition={false}
        fullScreen={useMediaQuery(useTheme().breakpoints.down("sm"))}
        onClose={handleClose}
        slots={{ transition: TransitionSlideUp }}
        aria-labelledby="form-dialog-title-hs5"
      >
        <AppBar style={{ position: "relative" }}>
          <Toolbar>
            <StandardText
              startIcon={
                <Icon style={{ color: "#fff" }}>{"assignment_add"}</Icon>
              }
              size={16}
              color={"#fff"}
              align="left"
            >
              {`Novo Registro`}
            </StandardText>

            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent dividers>
          <DialogContentText gutterBottom paddingBottom={2}>
            Registre uma transação para ser adicionada ao histórico de pontos do
            cliente
          </DialogContentText>

          <Grid container spacing={2} direction="row">
            <Grid size={{ xs: 12 }} container spacing={2}>
              <FieldSelector
                xs={12}
                forwardRef={(ref) => (refs.type = ref)}
                label="Tipo"
                onChange={(e) => {
                  setTransaction((p) => ({
                    ...p,
                    type: e.target.value,
                  }));
                }}
                //defaultValue=""
                value={transaction.type}
                options={transactionTypes}
              />
              <FieldSelector
                xs={12}
                forwardRef={(ref) => (refs.source = ref)}
                label="Origem"
                onChange={(e) => {
                  setTransaction((p) => ({
                    ...p,
                    source: e.target.value,
                  }));
                }}
                //defaultValue=""
                value={transaction.source}
                options={transactionSources}
              />
              <FieldText
                forwardRef={(ref) => (refs.description = ref)}
                label="Descrição"
                name="description"
                onChange={handleChange}
                xs={12}
              />

              <Grid item>
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Transação
                  </FormLabel>
                  <RadioGroup
                    value={transaction.multiplier}
                    onChange={(_, multiplier) =>
                      setTransaction((t) => ({
                        ...t,
                        multiplier: Number(multiplier),
                      }))
                    }
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="Entrada"
                    />
                    <FormControlLabel
                      value={-1}
                      control={<Radio />}
                      label="Saída"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <FieldText
                forwardRef={(ref) => (refs.amount = ref)}
                label="Pontos"
                name="amount"
                type="number"
                onChange={handleChange}
                xs={12}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={handleSave}
                disabled={!isValid}
              >
                Registrar
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <StandardButton onClick={handleClose}>
            <StandardText size={12}>Fechar</StandardText>
          </StandardButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default React.memo(RegisterComponent);
